import { createContext, useContext } from 'react'
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

type OrderEventsContext = {
  dispatchCancelOrder: (orderId: string) => void
  dispatchRefreshOrdersState: () => void
}

export const OrderEventsContext = createContext<OrderEventsContext | null>(null)

OrderEventsContext.displayName = 'OrderEventsContext'

export const useOrderEventsContext = () => {
  const hook = useContext(OrderEventsContext)

  if (hook === null) {
    const errorMessage = 'OrderEventsContext value is null'
    datadogLogs.logger.error(errorMessage)
    datadogRum.addError(new Error(errorMessage), {
      page: 'MyGoustoPage',
      errorMessage: errorMessage,
    })

    throw new Error('OrderEventsContext value is null')
  }

  return hook
}
